<template>
<div class="mx-5">
  <form @submit.prevent="submitForm"  class="max-w-md pt-10 mx-auto">
    <h1 class="flex text-2xl justify-center pt-5">Update Password</h1>
    <div class="relative mt-3 z-0 w-full mb-5 group">
      <input type="password" v-model="cPassword" name="floating_password" id="floating_password" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
      <label for="floating_password" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Current Password</label>
  </div>
  <div class="relative z-0 w-full mb-5 group">
      <input type="password" v-model="Password" name="floating_password" id="floating_password" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
      <label for="floating_password" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Password</label>
  </div>
  <div class="relative z-0 w-full mb-5 group">
      <input type="password" v-model="confirmPassword" name="repeat_password" id="floating_repeat_password" class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" placeholder=" " required />
      <label for="floating_repeat_password" class="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0 rtl:peer-focus:translate-x-1/4 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Confirm password</label>
  </div>

  <button type="submit"  class="text-white bg-bg-save hover:bg-hover-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
</form>
</div>

</template>

<script setup>
import axiosInstance from "@/plugins/axios"
import { ref, onMounted } from 'vue';
import Swal from 'sweetalert2';
const cPassword = ref()
const Password = ref()
const confirmPassword = ref()

const submitForm = async () => {
  try {
    // Check if Password and Confirm Password match
    if (Password.value !== confirmPassword.value) {
        Swal.fire({
          toast: true,
          title: 'new password and  confirmPassword ',
          icon: 'error',
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
      });
      throw new Error("Passwords don't match");
    }

    // Make API request to update password
    const response = await axiosInstance.put('/update-password', {
      current_password: cPassword.value,
      new_password: Password.value,
      new_password_confiramtion:confirmPassword.value
    });
    Swal.fire({
        toast: true,
        title: 'Successfully update Password ',
        icon: 'success',
        position: 'top-end',
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
    });

    // Reset form fields after successful password update
    cPassword.value = '';
    Password.value = '';
    confirmPassword.value = '';

    // Optionally, show a success message to the user
  } catch (error) {
    console.error('Error updating password:', error.response.data.message);
    Swal.fire({
          toast: true,
          title: error.response.data.message,
          icon: 'error',
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
      });
  }
};
</script>